<template>
  <div class="w-full fixed h-full login flex justify-center items-center mdmax:relative mdmax:h-screen">
    <div class="w-7/12 bg-white h-full" v-if="!isMobile">
      <div class="polygon bg-neutral-600 h-full flex items-center flex-col justify-center gap-10">
        <div class="flex justify-center items-center pr-15p">
          <img src="@/assets/images/logos/Logo-linknau-new.svg" class="w-56" />
        </div>
        <div class="w-full pr-15p">
          <carousel :options="carouselBannerOptions" :slides="slides">
            <template slot="content" slot-scope="{ item, index }">
              <img :src="item.image" class="inline-block mb-6" :id="'image-' + index" />
              <p class="w-3/5 mx-auto text-white">{{ item.description }}</p>
            </template>
          </carousel>
        </div>
      </div>
    </div>
    <div class="w-5/12 bg-white relative h-full mdmax:w-full">
      <div class="px-36 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10">
        <div class="text-center">
          <img src="@/assets/images/logos/linknau-logo.svg" class="inline-block" />
          <p class="font-bold text-2xl mt-10 mb-2 mdmax:mt-20">Reset Password</p>
          <p class="text-sm mb-14 text-neutral-500">Silahkan ubah password kamu, dengan password yang diinginkan.</p>
        </div>
        <div class="form mt-4 text-left">
          <div class="mb-8">
            <TextField type="password" v-model="payload.password" label="Password Baru" placeholder="Silahkan masukan password baru" @enter="doReset()" :error="errors['password']" />
          </div>
          <div class="mb-8">
            <TextField
              type="password"
              v-model="payload.passwordConfirmation"
              label="Konfirmasi Password Baru"
              placeholder="Silahkan masukan konfirmasi password baru"
              @enter="doReset()"
              :error="errors['passwordConfirmation']"
            />
          </div>
          <div class="login__form-submit">
            <transition name="fade" mode="out-in">
              <div class="text-system-error mb-4" v-if="generalError">{{ generalError }}</div>
            </transition>
            <Button @action="doReset()" buttonText="Reset" size="full" />
          </div>
        </div>
      </div>
    </div>
    <Toast />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'
const CONFIG = {
  password: 'Password',
  passwordConfirmation: 'Konfirmasi Password'
}
export default {
  name: 'Login',
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Carousel: () => import(/* webpackChunkName: "Carousel" */ '@/components/Carousel/Carousel'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Toast: () => import(/* webpackChunkName: "Toast" */ '@/components/Toast/Toast')
  },
  data: () => ({
    slides: [
      {
        image: require('@/assets/images/Login-1.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      },
      {
        image: require('@/assets/images/Login-2.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      },
      {
        image: require('@/assets/images/Login-3.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      }
    ],
    payload: {
      passwordConfirmation: null,
      password: null
    },
    errors: [],
    generalError: null,
    carouselBannerOptions: {
      rewind: true,
      arrows: false
    }
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userData']),
    ...mapGetters('common', ['isMobile']),
    token() {
      return this.$route.params.token
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    ...mapActions('merchant', ['setPassword']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    doReset() {
      if (this.validForm()) {
        if (this.payload.password !== this.payload.passwordConfirmation) {
          this.errors['passwordConfirmation'] = 'Password tidak sesuai'
          return
        }
        const requestBody = {
          password: this.payload.password,
          confirm_password: this.payload.passwordConfirmation
        }
        this.showLoading()
        this.generalError = null
        if (this.token) {
          this.setPassword({
            token: this.token,
            payloads: {
              password: this.payload.password,
              confirmation_password: this.payload.passwordConfirmation
            }
          })
            .then(() => {
              this.hideLoading()
              this.setToast({
                options: {
                  type: 'success',
                  duration: 2000,
                  primaryText: 'Password berhasil ditambahkan!',
                  secondaryText: '',
                  callback: this.handleCallBack
                }
              })
            })
            .catch(error => {
              this.hideLoading()
              this.setToast({
                options: {
                  type: 'danger',
                  duration: 5000,
                  primaryText: 'Password gagal ditambahkan!',
                  secondaryText: error.response.data.message,
                  callback: () => {}
                }
              })
            })
        } else {
          this.resetPassword({
            payloads: requestBody
          })
            .then(res => {
              this.hideLoading()
              if (this.userData.user.role_type === 'EXTERNAL') {
                this.$router.push('/dashboard')
              } else {
                this.$router.push('/dashboard')
              }
            })
            .catch(error => {
              this.hideLoading()
              this.generalError = error.response?.data?.message
            })
        }
      }
    },
    validForm() {
      const error = isNotEmptyError(this.payload)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    },
    handleCallBack() {
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
.login-form {
  max-width: 490px;
  margin: 0 auto;
}
.polygon {
  clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 0 0);
  height: 100%;
  width: 100%;
}
.pr-15p {
  padding-right: 15%;
}
</style>
